import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase";

interface RedirectIfAuthenticatedProps {
  element: React.ReactElement;
}

const RedirectIfAuthenticated: React.FC<RedirectIfAuthenticatedProps> = ({
  element,
}) => {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (user) {
    return <Navigate to="/" />;
  }

  return element;
};

export default RedirectIfAuthenticated;
